module.exports = __webpack_public_path__ + "img/chiromancy.b155723e.jpg";